import styled from "styled-components";
import loadAnimation from "../../../assets/animations/onLoad.json";
import LottieIcon from "../../../components/LottieIcon/LottieIcon";
import { useEffect, useState } from "react";

const Loader = ({ size = 124, text }) => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + "." : ""));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <LoaderContainer>
      <LottieIcon
        animationData={loadAnimation}
        size={size}
        trigger="loop"
        style={{
          zIndex: 1,
          marginBottom: -12,
          filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5))",
        }}
      />
      <div>
        <span>{text}</span>
        <span style={{ minWidth: 10 }}>{dots}</span>
      </div>
    </LoaderContainer>
  );
};

export default Loader;

const LoaderContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  flex: 1;
  gap: 6px;
  flex-direction: column;
  user-select: none;
  min-height: 400px;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  span {
    font-size: 16px;
    color: #666;
    font-family: Figtree;
  }
`;
